// pp-calc-comparador.js — Comparador de Precios de Empaque
// (/pages/comparador-de-precios-de-empaque)
//
// POR QUÉ EXISTE (idea de Padrino)
// El rollo "barato" del proveedor pirata sale caro cuando normalizas al costo
// por unidad REAL: si trae menos metros de los que promete, cada metro que sí
// usas te costó más. Aquí se capturan 2 o 3 cotizaciones y se comparan
// parejas: precio total ÷ unidades reales (metros de emplaye o piezas).
//
// La aritmética vive aquí y no en el <script> de la sección porque así se
// prueba con node a secas en tests/calc-comparador.test.mjs, igual que las
// demás calculadoras.
(function (root) {
  'use strict';

  // ── Fórmula de metros reales — COPIADA 1:1 de assets/pp-calc-emplaye.js ──
  // NO tocar aquí sin tocar allá: el comparador y el verificador deben contar
  // la misma historia (lo guarda tests/calc-comparador.test.mjs comparando
  // contra PPCalcEmplaye.analizarRollo):
  //   micras = calibre × 0.254
  //   g/m    = ancho_m × micras × 0.92   (densidad LLDPE, g/cm³)
  //   metros = peso de película (g) ÷ g/m
  var DENSIDAD_LLDPE = 0.92; // g/cm³ — película estirable estándar
  var MICRAS_POR_GAUGE = 0.254; // "cal. 60" ≈ 15 micras (60 × 0.254)
  var M_POR_FT = 0.3048;
  var M_POR_IN = 0.0254;

  function micrasDeCalibre(gauge) {
    return gauge * MICRAS_POR_GAUGE;
  }

  function gramosPorMetro(anchoM, micras) {
    return anchoM * micras * DENSIDAD_LLDPE;
  }
  // ── fin de la fórmula copiada ────────────────────────────────────────────

  // Normaliza UNA cotización a su costo por unidad comparable.
  //
  // tipo 'emplaye': { precio, largo, largoUnidad ('ft'|'m'), anchoIn, calibre,
  //   pesoRolloKg?, pesoNucleoKg? }. Si vienen los dos pesos, los metros se
  //   calculan REALES por peso (fórmula del verificador); si no, se toma el
  //   largo PROMETIDO de la etiqueta y esReal queda en false.
  // tipo 'pieza': { precio, piezas }.
  //
  // Devuelve null si las entradas no alcanzan, o { error: 'nucleo_mayor' }.
  function normalizarCotizacion(e, tipo) {
    if (!e) return null;
    var precio = num(e.precio);
    if (precio === null || precio <= 0) return null;

    if (tipo === 'pieza') {
      var piezas = num(e.piezas);
      if (piezas === null || piezas <= 0) return null;
      return { costoUnitario: precio / piezas, esReal: true, piezas: piezas, precio: precio };
    }

    if (tipo !== 'emplaye') return null;
    var largo = num(e.largo);
    if (largo === null || largo <= 0) return null;
    var largoPrometidoM = e.largoUnidad === 'ft' ? largo * M_POR_FT : largo;

    var pesoRollo = num(e.pesoRolloKg);
    var pesoNucleo = num(e.pesoNucleoKg);
    var conPesos = pesoRollo !== null && pesoRollo > 0 && pesoNucleo !== null && pesoNucleo >= 0;

    var metros = largoPrometidoM;
    var esReal = false;
    if (conPesos) {
      var anchoIn = num(e.anchoIn);
      var calibre = num(e.calibre);
      if (anchoIn === null || anchoIn <= 0 || calibre === null || calibre <= 0) return null;
      var pesoPlasticoKg = pesoRollo - pesoNucleo;
      if (pesoPlasticoKg <= 0) return { error: 'nucleo_mayor' };
      var gPorM = gramosPorMetro(anchoIn * M_POR_IN, micrasDeCalibre(calibre));
      metros = (pesoPlasticoKg * 1000) / gPorM;
      esReal = true;
    }

    return {
      costoUnitario: precio / metros,
      esReal: esReal,
      metros: metros,
      largoPrometidoM: largoPrometidoM,
      precio: precio,
      // En qué unidad la capturó el usuario. La aritmética SIEMPRE es en
      // metros —así el ranking no depende de la unidad— pero el veredicto se
      // presenta en lo que él escribió. Ver `comparar`.
      largoUnidad: e.largoUnidad === 'ft' ? 'ft' : 'm'
    };
  }

  // Compara 2 o 3 cotizaciones. Devuelve null si no alcanza para comparar
  // (menos de dos cotizaciones, o alguna con datos incompletos), o
  // { error, indice } si una cotización trae núcleo más pesado que el rollo.
  function comparar(e) {
    if (!e || (e.tipo !== 'emplaye' && e.tipo !== 'pieza')) return null;
    var crudas = e.cotizaciones;
    if (!crudas || crudas.length < 2) return null;

    var filas = [];
    for (var i = 0; i < crudas.length; i++) {
      var n = normalizarCotizacion(crudas[i], e.tipo);
      if (n === null) return null;
      if (n.error) return { error: n.error, indice: i };
      n.indice = i;
      filas.push(n);
    }

    var ganadorIdx = 0;
    var peorIdx = 0;
    for (var j = 1; j < filas.length; j++) {
      if (filas[j].costoUnitario < filas[ganadorIdx].costoUnitario) ganadorIdx = j;
      if (filas[j].costoUnitario > filas[peorIdx].costoUnitario) peorIdx = j;
    }
    var min = filas[ganadorIdx].costoUnitario;
    var max = filas[peorIdx].costoUnitario;

    var tieneReal = false;
    var tienePrometido = false;
    for (var k = 0; k < filas.length; k++) {
      if (filas[k].esReal) tieneReal = true;
      else tienePrometido = true;
    }

    /*
     * LA UNIDAD DEL VEREDICTO ES LA QUE CAPTURÓ EL USUARIO.
     *
     * El emplaye en México se cotiza EN PIES ("18, calibre 50, 800") y el
     * selector de largo ya venía en pies por omisión — pero el resultado salía
     * en metros y obligaba a convertir de cabeza, que es justo la fricción que
     * esta herramienta debería quitar. Pedido de Cristóbal (14-sep-2026).
     *
     * Si se MEZCLARON unidades entre cotizaciones no se elige ninguna: se
     * normaliza a metros. Inventar una conversión que el usuario no pidió es
     * peor que pedirle que lea metros.
     *
     * La aritmética de arriba NO cambia: sigue en metros. Ranking y
     * porcentajes son RAZONES, así que no dependen de la unidad — lo afirma
     * un caso del test. Aquí sólo se convierte lo que se pinta.
     */
    var unidad = 'pieza';
    var porUnidad = 1; // metros que vale una unidad de presentación
    if (e.tipo === 'emplaye') {
      var todasEnPies = filas.every(function (f) { return f.largoUnidad === 'ft'; });
      unidad = todasEnPies ? 'pie' : 'metro';
      porUnidad = todasEnPies ? M_POR_FT : 1;
    }
    for (var m = 0; m < filas.length; m++) {
      filas[m].costoMostrado = filas[m].costoUnitario * porUnidad;
      if (e.tipo === 'emplaye') filas[m].largoMostrado = filas[m].metros / porUnidad;
    }

    return {
      unidad: unidad,
      filas: filas,
      ganadorIdx: ganadorIdx,
      peorIdx: peorIdx,
      costoMin: min * porUnidad,
      costoMax: max * porUnidad,
      // Cuánto MÁS pagas por unidad con la cotización cara vs la ganadora.
      diferenciaPct: ((max - min) / min) * 100,
      // Cuánto te AHORRAS por unidad eligiendo a la ganadora (base: la cara).
      ahorroPct: ((max - min) / max) * 100,
      // En emplaye: una cotización medida por peso y otra por etiqueta no es
      // una comparación pareja — la UI lo marca con "verifícalo".
      mezclaRealYPrometido: e.tipo === 'emplaye' && tieneReal && tienePrometido
    };
  }

  function num(x) {
    if (x === null || x === undefined || x === '') return null;
    var v = Number(String(x).replace(',', '.'));
    return isFinite(v) ? v : null;
  }

  root.PPComparador = {
    DENSIDAD_LLDPE: DENSIDAD_LLDPE,
    micrasDeCalibre: micrasDeCalibre,
    gramosPorMetro: gramosPorMetro,
    normalizarCotizacion: normalizarCotizacion,
    comparar: comparar
  };
})(typeof window !== 'undefined' ? window : globalThis);

// ── Wiring de la página (no corre en tests de node) ────────────────────────
(function () {
  'use strict';
  if (typeof document === 'undefined') return;

  function listo(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  listo(function () {
    var raiz = document.querySelector('[data-pp-calc-comparador]');
    if (!raiz) return;
    var C = window.PPComparador;
    var $ = function (sel) { return raiz.querySelector(sel); };
    var form = $('form');
    var out = $('[data-calc-resultado]');
    var tipoSel = form.querySelector('[name="tipo"]');
    var bloqueC = $('[data-cot="c"]');
    var btnAgregar = $('[data-agregar-cotizacion]');

    var ETIQUETAS = { a: 'Cotización A', b: 'Cotización B', c: 'Cotización C' };

    // Telemetría anónima de uso (fire-and-forget), patrón de las demás
    // calculadoras. SOLO números — el nombre del proveedor es texto libre
    // (PII potencial) y JAMÁS se manda. Si falla, silencio.
    function telemetria(inputs, resultado) {
      try {
        var KEY = 'sb_publishable_48y6S7h2eQ-9uTF7pCNJNQ_Q0mz8VVX';
        fetch('https://dhygbnysealeblqorjts.supabase.co/functions/v1/calc-telemetria', {
          method: 'POST',
          keepalive: true,
          headers: { 'Content-Type': 'application/json', 'apikey': KEY, 'Authorization': 'Bearer ' + KEY },
          body: JSON.stringify({ calculadora: 'comparador', inputs: inputs, resultado: resultado })
        }).catch(function () {});
      } catch (_) { /* la telemetría jamás rompe la calculadora */ }
    }

    function fmt(n, dec) {
      return n.toLocaleString('es-MX', { maximumFractionDigits: dec === undefined ? 0 : dec, minimumFractionDigits: 0 });
    }

    // El atributo [hidden] PIERDE contra el display:grid/flex de pp-calc.css
    // (gotcha documentado en la propia hoja) — por eso los bloques se apagan
    // con la clase .hidden de base.css (display:none !important).
    function esconder(el, si) {
      if (el) el.classList.toggle('hidden', !!si);
    }

    function pintarTipo() {
      var esEmplaye = tipoSel.value === 'emplaye';
      raiz.querySelectorAll('[data-solo-emplaye]').forEach(function (el) { esconder(el, !esEmplaye); });
      raiz.querySelectorAll('[data-solo-pieza]').forEach(function (el) { esconder(el, esEmplaye); });
    }
    tipoSel.addEventListener('change', pintarTipo);
    pintarTipo();

    if (btnAgregar) {
      btnAgregar.addEventListener('click', function () {
        esconder(bloqueC, false);
        esconder(btnAgregar, true);
        var primero = bloqueC && bloqueC.querySelector('input');
        if (primero) primero.focus();
      });
    }

    function cotizacionVisible(sufijo) {
      return sufijo !== 'c' || (bloqueC && !bloqueC.classList.contains('hidden'));
    }

    function cruda(f, s) {
      if (tipoSel.value === 'emplaye') {
        return {
          precio: f.get('precio_' + s),
          largo: f.get('largo_' + s),
          largoUnidad: f.get('largo_unidad_' + s),
          anchoIn: f.get('ancho_' + s),
          calibre: f.get('calibre_' + s),
          pesoRolloKg: f.get('peso_rollo_' + s),
          pesoNucleoKg: f.get('peso_nucleo_' + s)
        };
      }
      return { precio: f.get('precio_' + s), piezas: f.get('piezas_' + s) };
    }

    // El nombre del proveedor SOLO viaja del input al DOM, y SOLO por
    // textContent (nunca innerHTML, nunca telemetría).
    function nombre(f, s) {
      var v = String(f.get('proveedor_' + s) || '').trim();
      return v || ETIQUETAS[s];
    }

    function el(tag, clase, texto) {
      var n = document.createElement(tag);
      if (clase) n.className = clase;
      if (texto !== undefined && texto !== null) n.textContent = texto;
      return n;
    }

    function chip(mod, texto) {
      return el('span', 'pp-calc__chip pp-calc__chip--' + mod, texto);
    }

    function linkVerificador(texto) {
      var a = el('a', 'pp-calc__cierre-link', texto);
      a.href = '/pages/verificador-de-emplaye';
      return a;
    }

    // conTelemetria: solo el submit explícito reporta; el recálculo en vivo
    // al editar campos no, para no llenar la tabla con teclazos intermedios.
    function correr(conTelemetria) {
      var f = new FormData(form);
      var sufijos = ['a', 'b'];
      // La tercera cotización cuenta solo si está visible Y trae precio.
      if (cotizacionVisible('c') && String(f.get('precio_c') || '').trim() !== '') sufijos.push('c');

      var r = C.comparar({
        tipo: tipoSel.value,
        cotizaciones: sufijos.map(function (s) { return cruda(f, s); })
      });
      pintar(r, f, sufijos);

      if (conTelemetria && r && !r.error) {
        var esEmplaye = tipoSel.value === 'emplaye';
        var red4 = function (n) { return Math.round(n * 10000) / 10000; };
        telemetria(
          {
            es_emplaye: esEmplaye ? 1 : 0,
            precio_a: r.filas[0].precio,
            precio_b: r.filas[1].precio,
            precio_c: r.filas[2] ? r.filas[2].precio : null,
            largo_prometido_m_a: esEmplaye ? Math.round(r.filas[0].largoPrometidoM * 10) / 10 : null,
            largo_prometido_m_b: esEmplaye ? Math.round(r.filas[1].largoPrometidoM * 10) / 10 : null
          },
          {
            costo_unitario_min: red4(r.costoMin),
            costo_unitario_max: red4(r.costoMax),
            diferencia_pct: Math.round(r.diferenciaPct * 10) / 10
          }
        );
      }
    }

    function pintar(r, f, sufijos) {
      if (!out) return;
      out.hidden = false;
      out.textContent = '';

      if (!r) {
        out.appendChild(el('p', 'pp-calc__error', 'Revisa los datos: cada cotización necesita precio y ' + (tipoSel.value === 'emplaye' ? 'largo prometido (con ancho y calibre si capturas pesos)' : 'cantidad de piezas') + ', todos mayores a cero.'));
        return;
      }
      if (r.error === 'nucleo_mayor') {
        out.appendChild(el('p', 'pp-calc__error', 'En "' + nombre(f, sufijos[r.indice]) + '" el núcleo pesa igual o más que el rollo completo — revisa que ambos pesos estén en kilogramos.'));
        return;
      }

      var nombres = sufijos.map(function (s) { return nombre(f, s); });
      var hayReal = r.filas.some(function (fila) { return fila.esReal; });
      // "metro"/"pie" se comportan igual aquí; sólo "pieza" siempre es real.
      var esLargo = r.unidad === 'metro' || r.unidad === 'pie';
      var abrev = r.unidad === 'pie' ? 'ft' : 'm';
      var etiquetaUnidad = esLargo && !hayReal ? r.unidad + ' prometido' : r.unidad + ' real';
      var empate = r.diferenciaPct < 0.05;

      var vd = el('div', 'pp-calc__veredicto pp-calc__veredicto--ok');
      vd.appendChild(el('p', 'pp-calc__veredicto-titulo', empate
        ? 'Por ' + etiquetaUnidad + ', las cotizaciones salen prácticamente iguales.'
        : 'Por ' + etiquetaUnidad + ', ' + nombres[r.ganadorIdx] + ' te sale ' + fmt(r.ahorroPct, 1) + '% más barato.'));
      vd.appendChild(el('p', 'pp-calc__veredicto-dato', 'Costo por ' + r.unidad + ': de $' + fmt(r.costoMin, 2) + ' a $' + fmt(r.costoMax, 2) + ' MXN — el más caro paga ' + fmt(r.diferenciaPct, 1) + '% más por cada ' + r.unidad + '.'));
      out.appendChild(vd);

      var dl = el('dl', 'pp-calc__detalle');
      r.filas.forEach(function (fila, i) {
        var fdiv = el('div', 'pp-calc__detalle-fila');
        var dt = el('dt');
        dt.appendChild(el('span', null, nombres[i]));
        if (!empate && i === r.ganadorIdx) {
          dt.appendChild(document.createTextNode(' '));
          dt.appendChild(chip('ok', 'El más barato'));
        } else if (!empate && i === r.peorIdx && r.diferenciaPct > 15) {
          dt.appendChild(document.createTextNode(' '));
          dt.appendChild(chip('rojo', 'El más caro'));
        }
        fdiv.appendChild(dt);

        var dd = el('dd');
        dd.appendChild(document.createTextNode('$' + fmt(fila.costoMostrado, 2)));
        if (esLargo) {
          if (fila.esReal) {
            dd.appendChild(el('span', 'pp-calc__ayuda', ' por ' + r.unidad + ' REAL (' + fmt(fila.largoMostrado) + ' ' + abrev + ' medidos por peso)'));
          } else if (r.mezclaRealYPrometido) {
            var aviso = el('span', 'pp-calc__ayuda', ' por ' + r.unidad + ' PROMETIDO — ');
            aviso.appendChild(linkVerificador('verifícalo'));
            dd.appendChild(aviso);
          } else {
            dd.appendChild(el('span', 'pp-calc__ayuda', ' por ' + r.unidad + ' prometido (' + fmt(fila.largoMostrado) + ' ' + abrev + ' de etiqueta)'));
          }
        } else {
          dd.appendChild(el('span', 'pp-calc__ayuda', ' por pieza (' + fmt(fila.piezas) + ' pzas)'));
        }
        fdiv.appendChild(dd);
        dl.appendChild(fdiv);
      });
      out.appendChild(dl);

      if (r.mezclaRealYPrometido) {
        // Cuando hay mezcla real/prometido la unidad puede ser pie o metro; el
        // texto usa la que se está mostrando.
        var nota = el('p', 'pp-calc__nota', 'Ojo: estás comparando ' + r.unidad + 's MEDIDOS por peso contra ' + r.unidad + 's de ETIQUETA — no es una comparación pareja. Pesa el rollo de la cotización marcada en el ');
        nota.appendChild(linkVerificador('Verificador de Emplaye'));
        nota.appendChild(document.createTextNode(' y vuelve a comparar con sus metros reales.'));
        out.appendChild(nota);
      } else if (r.unidad === 'metro' && !hayReal) {
        var nota2 = el('p', 'pp-calc__nota', 'Los dos costos usan el largo de etiqueta. Si algún rollo trae menos película de la prometida, su costo real es mayor — al recibirlo, pésalo en el ');
        nota2.appendChild(linkVerificador('Verificador de Emplaye'));
        nota2.appendChild(document.createTextNode('.'));
        out.appendChild(nota2);
      }
    }

    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      correr(true);
      if (out) out.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    });

    // Con el resultado ya visible, editar cualquier campo recalcula solo.
    var timerRecalc = null;
    function recalcEnVivo() {
      if (!out || out.hidden) return;
      clearTimeout(timerRecalc);
      timerRecalc = setTimeout(function () { correr(false); }, 350);
    }
    form.addEventListener('input', recalcEnVivo);
    form.addEventListener('change', recalcEnVivo);
  });
})();
